export default __webpack_public_path__ + "static/2_1-5ccddde4ecddc6e2b8043fb2cad1600d.jpg";